import { Dispatch, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AuthenticationActionCreator } from '../../actions/AuthenticationActionCreator';
import Alert from '../../core/Alert';
import useUniqueId from '../../core/useUniqueId';
import { isError } from '../../models/core/error/IError';
import CookieStorageAPI from 'core/storage/CookieStorageAPI';
import { addMinutes } from 'date-fns';
import { IAppleRegistrationCredentials } from '../../models/authentication/registration/IAppleRegistrationCredentials';

export function useAppleLoginHandler() {
    const dispatch = useDispatch();
    const deviceId = useUniqueId();

    const onLoginFinished = useCallback(
        async (result: any) => {
            if (!result.user) {
                Alert.alert('Anmelden fehlgeschlagen!', 'Bitte versuche es erneut.');
                return;
            }

            const response = await dispatch(AuthenticationActionCreator.loginAppleUser({
                email: result.email,
                authorizationCode: result.authorizationCode // or the correct property from result
            }));

            if (isError(response)) {
                // User is not registered yet, register user
                const registerData: IAppleRegistrationCredentials = {
                    appleToken: result.user,
                    email: result.email,
                    deviceId: deviceId,
                    pushPreference: false,
                    firebaseId: '',
                    platform: 'web',
                    authorization: result.authorization || '',
                    user: {
                        email: result.email,
                        name: {
                            firstName: result.name?.firstName || result.name?.givenName || 'User'
                        }
                    }
                };

                const registerResponse = await dispatch(AuthenticationActionCreator.registerAppleUser(registerData));

                if (isError(registerResponse)) {
                    Alert.alert('Registrierung Fehlgeschlagen!', 'Bitte versuche es erneut.');
                    return;
                }

                Alert.alert('Geschafft!', 'Du bist jetzt Startklar und kannst beginnen, dich mit Leuten aus deiner Umgebung zu verbinden.');
            }

            CookieStorageAPI.setItem('loggedIN', 'true', { expires: addMinutes(new Date(), 5) });
        },
        [dispatch, deviceId]
    );

    return onLoginFinished;
}

export default useAppleLoginHandler;
